import { Routes, Route } from 'react-router-dom';
import ValidarForm from './components/ValidarForm/ValidarForm';
import CadastrarTokenForm from './components/ValidarForm/CadastrarToken';
import AlterarSenha from './components/RecuperarLoginForm/AlterarSenha';
import Principal from './components/Principal/Principal';
import LoginForm from './components/LoginForm/LoginForm';
import CrmShell from './crm/CrmShell';
import React from 'react';

 
const App = () => {
   return (
    <Routes>
      <Route path="/" element={<LoginForm/>} />
      <Route path="/validar" element={<ValidarForm/>} />
      <Route path="/cadastrar_token" element={<CadastrarTokenForm/>} />
      <Route path="/alterar_senha" element ={<AlterarSenha/>}/>
      <Route path="/alterar_senha_obrigatoria" element ={<AlterarSenha/>}/>
      <Route path="/principal" element ={<Principal/>}/>
      <Route path="/crm" element ={<CrmShell/>}/>
    </Routes>
  );
};
 
export default App;
